class JalecoBundle extends HTMLElement {
  constructor() {
    super();
    this.slots = parseInt(this.dataset.slots, 10);
    this.variants = JSON.parse(this.querySelector('[data-jb-variants]').textContent);
    this.selected = [];
    this.size = '';

    this.els = {
      count: this.querySelector('[data-jb-count]'),
      slotsWrap: this.querySelector('[data-jb-slots]'),
      colors: this.querySelectorAll('[data-jb-color]'),
      sizes: this.querySelectorAll('[data-jb-size]'),
      addSlot: this.querySelector('[data-jb-add-slot]'),
      submit: this.querySelector('[data-jb-submit]'),
      mainImage: this.querySelector('[data-jb-main-image]'),
      thumbs: this.querySelectorAll('[data-jb-thumb]'),
      thumbsTrack: this.querySelector('[data-jb-thumbs]'),
      prev: this.querySelector('[data-jb-prev]'),
      next: this.querySelector('[data-jb-next]')
    };

    this.color = this.querySelector('[data-jb-color].is-active').dataset.jbColor;
    this.preloadColorImages();
    this.bind();
    this.render();
  }

  preloadColorImages() {
    const seen = {};
    this.variants.forEach((v) => {
      if (v.featured_image && !seen[v.featured_image.src]) {
        seen[v.featured_image.src] = true;
        const img = new Image();
        img.src = v.featured_image.src;
      }
    });
  }

  bind() {
    this.els.colors.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.color = btn.dataset.jbColor;
        this.els.colors.forEach((b) => b.classList.toggle('is-active', b === btn));
        this.showColorImage();
        this.updateAddState();
      });
    });

    this.els.sizes.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.size = btn.dataset.jbSize;
        this.els.sizes.forEach((b) => b.classList.toggle('is-active', b === btn));
        this.updateAddState();
      });
    });

    this.els.thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.els.mainImage.src = btn.dataset.jbThumb;
        this.els.thumbs.forEach((b) => b.classList.toggle('is-active', b === btn));
      });
    });

    this.els.prev.addEventListener('click', () => {
      this.els.thumbsTrack.scrollBy({ left: -200 });
    });

    this.els.next.addEventListener('click', () => {
      this.els.thumbsTrack.scrollBy({ left: 200 });
    });

    this.els.addSlot.addEventListener('click', () => this.addToSelection());
    this.els.submit.addEventListener('click', () => this.submit());

    this.els.slotsWrap.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-jb-remove]');
      if (!btn) return;
      const slot = btn.closest('[data-jb-slot]');
      this.removeFromSelection(parseInt(slot.dataset.jbSlot, 10));
    });
  }

  findVariant(color, size) {
    return this.variants.find((v) => v.option1 === color && v.option2 === size);
  }

  showColorImage() {
    const variant = this.variants.find((v) => v.option1 === this.color && v.featured_image);
    if (variant) {
      this.els.mainImage.src = variant.featured_image.src;
    }
  }

  updateAddState() {
    const variant = this.findVariant(this.color, this.size);
    const full = this.selected.length >= this.slots;
    this.els.addSlot.disabled = !variant || !variant.available || full;
  }

  addToSelection() {
    const variant = this.findVariant(this.color, this.size);
    this.selected.push(variant);
    this.render();
  }

  removeFromSelection(index) {
    this.selected.splice(index, 1);
    this.render();
  }

  render() {
    const slotEls = this.els.slotsWrap.querySelectorAll('[data-jb-slot]');
    slotEls.forEach((slotEl, i) => {
      const variant = this.selected[i];
      const label = slotEl.querySelector('.jaleco-bundle__slot-empty');
      const remove = slotEl.querySelector('[data-jb-remove]');
      slotEl.classList.toggle('is-filled', Boolean(variant));
      label.textContent = variant ? `${variant.option1} / ${variant.option2}` : 'Vazio';
      remove.hidden = !variant;
    });

    this.els.count.textContent = this.selected.length;

    const faltam = this.slots - this.selected.length;
    this.els.submit.disabled = faltam !== 0;
    this.els.submit.textContent = faltam === 0
      ? 'Adicionar ao carrinho'
      : faltam === 1
        ? 'Falta 1 peça'
        : `Faltam ${faltam} peças`;

    this.updateAddState();
  }

  async submit() {
    const items = this.selected.map((v) => ({ id: v.id, quantity: 1 }));
    this.els.submit.disabled = true;
    this.els.submit.textContent = 'Adicionando...';

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (res.ok) {
      window.location.href = '/cart';
    } else {
      this.els.submit.textContent = 'Erro, tente de novo';
      this.els.submit.disabled = false;
    }
  }
}

customElements.define('jaleco-bundle', JalecoBundle);